import { format } from 'date-fns';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { AccountContext } from '../../context/account';
import { UserContext } from '../../context/UserContext';
import { ISubject } from '../../lib/helpers/types';
import { Card } from '../ui';
import { variables, Viewport } from '../utils';
import { CaptionCardNotSmall, CaptionCardSmall } from './CaptionCard';
import { DataCardNotSmall, DataCardSmall } from './DataCard';
import { PrivateNoteCardNotSmall, PrivateNoteCardSmall } from './PrivateNoteCard';
import EditBar from './EditBar';
import { MemberAvatar } from '../ui';

interface TimelineEntry {
  note: {
    id: string;
    composedBy: {
      id: string;
      displayName: string;
      user: {
        avatarUrl: string | null | undefined;
      };
    };
    subjects: ISubject[];
    measurements: {
      subject: {
        id: string;
      };
      tracker: {
        id: string;
      };
      value: number;
    }[];
    notedAt: any;
    context: string | null;
    content: string | null;
  };
}

const LeftCol = styled.div.attrs({
  className: 'w-50-ns ph2 b--navy pt2-ns pb4-ns'
})`
  @media (min-width: ${variables.medium}px) {
    border-right: 1px solid;
  }
`;

const RightCol = styled.div.attrs({
  className: 'w-50-ns ph2 b--navy pt2-ns pb4-ns'
})``;

function isEntryAuthor(note: { composedBy: { id: string } }, memberId: string): boolean {
  return note.composedBy.id === memberId;
}

const TimelineEntry: React.FunctionComponent<TimelineEntry> = ({ note }) => {
  const accountContext = useContext(AccountContext);
  const { user } = useContext(UserContext);
  const memberId = user.memberIdForAccount(accountContext.selectedAccountId);

  return (
    <div data-testid="timeline-entry">
      <div className="flex-auto flex justify-center">
        <p className="f8 light-silver tr w-50 pr2" data-testid="composed-by">
          {note.composedBy.displayName}
        </p>
        <MemberAvatar member={note.composedBy} size={30} />
        <p className="flex-auto tl f8 light-silver w-50 pl2">{format(note.notedAt, 'h:mm a')}</p>
      </div>
      <div className="db dn-ns center bg-navy" style={{ height: 8, width: 1 }} />

      <div className="flex-ns h-100 w-100">
        <Viewport
          small={
            <Card>
              <DataCardSmall note={note} isEntryAuthor={isEntryAuthor(note, memberId)} />
              {note.context && <CaptionCardSmall caption={note.context} />}
              {note.content && <PrivateNoteCardSmall content={note.content} />}
              {isEntryAuthor && (
                <EditBar note={note} isEntryAuthor={isEntryAuthor(note, memberId)} />
              )}
            </Card>
          }
          notSmall={
            <>
              <LeftCol>
                <DataCardNotSmall note={note} isEntryAuthor={isEntryAuthor(note, memberId)} />
              </LeftCol>
              <RightCol>
                {note.context && <CaptionCardNotSmall caption={note.context} />}
                {note.content && <PrivateNoteCardNotSmall content={note.content} />}
              </RightCol>
            </>
          }
        />
      </div>

      <div className="db dn-ns center bg-navy" style={{ height: 16, width: 1 }} />
    </div>
  );
};

export default TimelineEntry;
